import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { switchMap, map, catchError, throwError, mergeMap, of } from 'rxjs';
import {
  CREATE_UTENZA,
  CREATE_UTENZA_SUCCESS,
  DOWNLOAD_LDV_DOC,
  DOWNLOAD_UTILITY_REPORT_PUNTO_POSTE,
  RETRIEVE_GESTIONE_UTENZE,
  RETRIEVE_GESTIONE_UTENZE_SUCCESS,
  RETRIEVE_LISTA_RETE_TERZE,
  RETRIEVE_LISTA_RETE_TERZE_SUCCESS,
  RETRIEVE_COMPENSI_RETE,
  RETRIEVE_COMPENSI_RETE_POST,
  RETRIEVE_COMPENSI_RETE_POST_SUCCESS,
  RETRIEVE_COMPENSI_RETE_SUCCESS,
  RETRIEVE_RETE_TERZA_LIST,
  RETRIEVE_RETE_TERZA_LIST_SUCCESS,
  RETRIEVE_UTILITY_LDV,
  RETRIEVE_UTILITY_LDV_SUCCESS,
  UPLOAD_DOCUMENT_LDV,
  UPLOAD_DOCUMENT_LDV_SUCCESS,
  RETRIEVE_CONFIGURAZIONE_BOXLESS,
  RETRIEVE_CONFIGURAZIONE_BOXLESS_SUCCESS,
  RETRIEVE_CONFIGURAZIONE_BOXLESS_POST,
  RETRIEVE_CONFIGURAZIONE_BOXLESS_POST_SUCCESS,
  RETRIEVE_NEARLIST_XLS,
  RETRIEVE_NEARLIST_UFF_POSTALE,
  RETRIEVE_NEARLIST_UFF_POSTALE_SUCCESS,
  DOWNLOAD_LISTA_RECAPITO,
  RETRIEVE_CD_GO,
  RETRIEVE_CD_GO_SUCCESS,
  RETRIEVE_FRAZ,
  RETRIEVE_FRAZ_SUCCESS,
  RETRIEVE_GO,
  RETRIEVE_GO_SUCCESS,
  RETRIEVE_RAM_GO,
  RETRIEVE_RAM_GO_SUCCESS,
  SEARCH_LISTA_RECAPITO,
  SEARCH_LISTA_RECAPITO_SUCCESS,
  RETRIEVE_RECAPITO,
  RETRIEVE_RECAPITO_SUCCESS,
  RETRIEVE_LISTA_CATALOGO_MATERIALE,
  DOWNLOAD_CATALOGO_MATERIALE,
  RETRIEVE_LISTA_CATALOGO_MATERIALE_SUCCESS,
  RETRIEVE_LISTA_CLUSTER,
  RETRIEVE_LISTA_CLUSTER_SUCCESS,
  SAVE_LISTA_CATALOGO_MATERIALE,
  RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO,
  SAVE_CONFIGURAZIONE_APPROVIGIONAMENTO,
  RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO_SUCCESS,
  RETRIEVE_REGOLE_ORDINE,
  RETRIEVE_REGOLE_ORDINE_SUCCESS,
  RETRIEVE_ORDER_HISTORY,
  RETRIEVE_ORDER_HISTORY_SUCCESS,
  RETRIEVE_STORICO_ORDINI_PARTNER,
  RETRIEVE_STORICO_ORDINI_PARTNER_SUCCESS,
  RETRIEVE_STORICO_ORDINI_PROFILI,
  RETRIEVE_STORICO_ORDINI_PROFILI_SUCCESS,
  DOWNLOAD_REPORT_ORDER_HISTORY,
  RETRIEVE_CREATE_ORDER,
  RETRIEVE_CREATE_ORDER_SUCCESS,
  CHANGE_QUANTITY_CREATE_ORDER,
  RETRIVE_LISTA_FRAZIONARIO,
  RETRIVE_LISTA_FRAZIONARIO_SUCCESS,
  RETRIEVE_PIN_RECOVERY,
  RETRIEVE_PIN_RECOVERY_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
} from './utilities.actions';
import { RetrieveUtilityLdv } from '../../interfaces/retrieve-utility-ldv';
import {
  IPayloadCreazioneUtenza,
  IResponseCreazioneUtenza,
  IResponseGestioneUtenze,
} from '../../interfaces/gestione-utenze';
import { GenericResponse } from '../../interfaces/generic-response';
import {
  ADD_TOAST_NOTIFICATION,
  DOWNLOAD_FILE,
} from '../config/config.actions';
import {
  IPayloadDownloadUtilityReportPuntoPoste,
  IResponseListaReteTerze,
} from '../../interfaces/utility-report-punto-poste';
import {
  IResponseCompensiRete,
  IResponseCompensiRetePost,
} from '../../interfaces/compensi';
import { ResponseAnagraphicManagement } from '../../interfaces/response-anagraphic-management';
import { IConfigurazioneBoxless } from '../../interfaces/configurazione-boxless';
import { ResponseNearlistUffPostale } from '../../interfaces/nearlist';
import dayjs from 'dayjs';
import { ResponseCercaPerStrutturaRecapito } from '../../interfaces/cerca-per-struttura-recapito';
import {
  IResponseGo,
  IResponseRamGo,
  IResponseCdGo,
  IResponseFraz,
  IResponseRecapito,
} from '../../interfaces/go';
import { PayloadCercaStrutturaRecapito } from '../../interfaces/payload-cerca-struttura-recapito';
import {
  IResponseListaCatalogoMateriale,
  ISaveListaCatalogoMateriale,
} from '../../interfaces/catalogo-materiale';
import { IResponseCluster } from '../../interfaces/cluster';
import { EsitoEnum } from '../../enum/esito.enum';
import {
  IPayloadConfigurazioneApprovvigionamento,
  IResponseConfigurazioneApprovvigionamento,
  IResponseOrdiniApprovvigionamento,
} from '../../interfaces/configurazione-approvvigionamento';
import { IResponseRegoleOrdine } from '../../interfaces/regole-ordine';
import { PayloadOrderHistory } from '../../interfaces/payload-order-history';
import { ResponseOrderHistory } from '../../interfaces/response-order-history';
import { ResponseCreazioneOrdine } from '../../interfaces/response-creazione-ordine';
import { NotificationTypeEnum, today } from '@poste-click-connect/shared-ui';
import { IPinRecoveryPayload, IResponsePinRecovery } from '../../interfaces/pin-recovery';
import { IResponseStoricoOrdiniPartner, IResponseStoricoOrdiniProfili } from '../../interfaces/storico-ordini-filter-options';

@Injectable()
export class UtilitiesEffects {
  retrieveUtilityLdv$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_UTILITY_LDV),
      switchMap(({ payload }: { payload: string }) => {
        return this.api.retrieveUtilityLdv(payload);
      }),
      map((responseUtilityLdv: RetrieveUtilityLdv) => {
        return RETRIEVE_UTILITY_LDV_SUCCESS({ responseUtilityLdv });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadDocumentLdv$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_DOCUMENT_LDV),
      switchMap(
        ({
          payload,
          idSpedizione,
          state,
        }: {
          payload: FormData;
          idSpedizione: string;
          state: string;
        }) => {
          return this.api.uploadDocumentLdv(payload, idSpedizione, state);
        }
      ),
      mergeMap((responseDocumentoLdv: GenericResponse) => {
        return [
          UPLOAD_DOCUMENT_LDV_SUCCESS({
            responseDocumentoLdv,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveGestioneUtenze$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_GESTIONE_UTENZE),
      switchMap(() => {
        return this.api.retrieveGestioneUtenze();
      }),
      map((responseGestioneUtenze: IResponseGestioneUtenze) => {
        return RETRIEVE_GESTIONE_UTENZE_SUCCESS({ responseGestioneUtenze });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  creazioneUtenza$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CREATE_UTENZA),
      switchMap(({ payload }: { payload: IPayloadCreazioneUtenza }) => {
        return this.api.retrieveCreazioneUtenza(payload);
      }),
      mergeMap((responseCreazioneUtenza: IResponseCreazioneUtenza) => {
        return [
          CREATE_UTENZA_SUCCESS({
            responseCreazioneUtenza,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCreazioneOrdine$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CREATE_ORDER),
      switchMap(({ payload }: { payload: any }) => {
        return this.api.retrieveCreazioneOrdine(payload);
      }),
      mergeMap((responseCreazioneOrdine: ResponseCreazioneOrdine) => {
        return [
          RETRIEVE_CREATE_ORDER_SUCCESS({
            responseCreazioneOrdine,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  changeQuantityCreateOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CHANGE_QUANTITY_CREATE_ORDER),
      switchMap(({ payload }: { payload: any }) => {
        return this.api.changeQuantityCreateOrder(payload);
      }),
      map((response: GenericResponse) => {
        if (response.esito === EsitoEnum.OK) {
          return ADD_TOAST_NOTIFICATION({
            notificationMessage: {
              type: NotificationTypeEnum.SUCCESS,
              description: 'Ordine creato con successo.',
            },
          });
        }

        return ADD_TOAST_NOTIFICATION({
          notificationMessage: {
            type: NotificationTypeEnum.ERROR,
            description: response.errorDescr || 'Ordine non creato.',
          },
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadLdvDoc$ = createEffect(() => {
    let id: string = '';
    return this.actions$.pipe(
      ofType(DOWNLOAD_LDV_DOC),
      switchMap(({ payload }: { payload: string }) => {
        id = payload;
        return this.api.downloadLdvDoc(payload);
      }),
      map((response: Blob) => {
        return DOWNLOAD_FILE({
          file: response,
          fileName: `${id}_Documents`,
          blobType: 'application/zip;charset=utf-8',
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveListaReteTerze$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_LISTA_RETE_TERZE),
      switchMap(() => {
        return this.api.retrieveListaReteTerze();
      }),
      map((responseListaReteTerze: IResponseListaReteTerze) => {
        return RETRIEVE_LISTA_RETE_TERZE_SUCCESS({ responseListaReteTerze });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReteTerzaList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RETE_TERZA_LIST),
      switchMap(() => {
        return this.api.retrieveAnagrafica();
      }),
      map((responseReteTerzaList: ResponseAnagraphicManagement) => {
        return RETRIEVE_RETE_TERZA_LIST_SUCCESS({ responseReteTerzaList });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadUtilityReportPuntoPoste$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_UTILITY_REPORT_PUNTO_POSTE),
      switchMap(
        ({ payload }: { payload: IPayloadDownloadUtilityReportPuntoPoste }) => {
          return this.api.downloadUtilityReportPuntoPoste(payload);
        }
      ),
      mergeMap((response: HttpResponse<Blob>) => {
        if (!(response.body as unknown as ArrayBuffer)?.byteLength) {
          return [
            ADD_TOAST_NOTIFICATION({
              notificationMessage: {
                type: NotificationTypeEnum.ERROR,
                description: 'Nessun Punto Poste rispetta i criteri di ricerca',
              },
            }),
          ];
        }
        const fileName = response.headers.get('content-disposition');

        return [
          DOWNLOAD_FILE({
            file: response.body as Blob,
            fileName: fileName?.substr(17, 50) || 'report_punto_poste',
          })
        ] // fileName.substr(17, 50) preso dal vecchio BO
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCompensiRete$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_COMPENSI_RETE),
      switchMap(({ rete }) => {
        return this.api.retrieveCompensiRete(rete);
      }),
      map((responseCompensiRete: IResponseCompensiRete) => {
        return RETRIEVE_COMPENSI_RETE_SUCCESS({ responseCompensiRete });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCompensiRetePost$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_COMPENSI_RETE_POST),
      switchMap(({ rete, file }) => {
        return this.api.retrieveCompensiRetePost(rete, file).pipe(
          map(responseCompensiRetePost => ({responseCompensiRetePost, rete}))
        );
      }),
      mergeMap(({responseCompensiRetePost, rete}) => {
        return [
          RETRIEVE_COMPENSI_RETE_POST_SUCCESS({
          responseCompensiRetePost,
        }),
        RETRIEVE_COMPENSI_RETE({rete})
      ]
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveConfigurazioneBoxless$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CONFIGURAZIONE_BOXLESS),
      switchMap(() => {
        return this.api.retrieveConfigurazioneBoxless();
      }),
      map((responseConfigurazioneBoxless: IConfigurazioneBoxless) => {
        return RETRIEVE_CONFIGURAZIONE_BOXLESS_SUCCESS({
          responseConfigurazioneBoxless,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveConfigurazioneBoxlessPost$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CONFIGURAZIONE_BOXLESS_POST),
      switchMap(({ payload }) => {
        return this.api.retrieveConfigurazioneBoxlessPost(payload);
      }),
      map((responseConfigurazioneBoxlessPost: IConfigurazioneBoxless) => {
        return RETRIEVE_CONFIGURAZIONE_BOXLESS_POST_SUCCESS({
          responseConfigurazioneBoxlessPost,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveFrazionarioList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_NEARLIST_UFF_POSTALE),
      switchMap(({ uffPostale }) => {
        return this.api.retrieveFrazionarioList(uffPostale);
      }),
      map((responseNearlistUffPostale: ResponseNearlistUffPostale) => {
        return RETRIEVE_NEARLIST_UFF_POSTALE_SUCCESS({
          responseNearlistUffPostale,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveFrazionarioXls$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_NEARLIST_XLS),
      switchMap(({ payload }) => this.api.retrieveFrazionarioXls(payload)),
      map((response: Blob) => {
        const fileName = 'Report_Frazionario.xlsx';
        return DOWNLOAD_FILE({ file: response, fileName: fileName });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  searchListaRecapito$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SEARCH_LISTA_RECAPITO),
      switchMap(({ payload }: { payload: PayloadCercaStrutturaRecapito }) => {
        return this.api.cercaPerStrutturaRecapito(payload);
      }),
      map((responseCercaRecapito: ResponseCercaPerStrutturaRecapito) => {
        return SEARCH_LISTA_RECAPITO_SUCCESS({ responseCercaRecapito });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadListaRecapito$ = createEffect(() => {
    let name: string = '';
    return this.actions$.pipe(
      ofType(DOWNLOAD_LISTA_RECAPITO),
      switchMap(
        ({
          payload,
        }: {
          payload: Partial<ResponseCercaPerStrutturaRecapito>;
        }) => {
          name = payload?.listaRecapito?.nome || '';
          return this.api.downloadListaRecapito(payload);
        }
      ),
      map((file: Blob) => {
        const todaydate = dayjs(today()).format('YYYYMMDDHHmmss')

        const fileName = `EstrazionePuntoPoste_${name}_${todaydate}.xlsx`;

        return DOWNLOAD_FILE({
          file,
          fileName: fileName || 'EstrazionePuntoPoste.xlsx',
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadReportOrderHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_REPORT_ORDER_HISTORY),
      switchMap(({ payload }: { payload: PayloadOrderHistory }) => {
        return this.api.downloadReportOrderHistory(payload);
      }),
      map((file: Blob) => {
        return DOWNLOAD_FILE({
          file,
          fileName: `Storico_Ordini.xlsx`,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveGo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_GO),
      switchMap(({ payload }) => this.api.retrieveGo(payload)),
      mergeMap((responseGo: IResponseGo) => {
        return [
          RETRIEVE_GO_SUCCESS({
            responseGo,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRamGo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RAM_GO),
      switchMap(({ payload }) => this.api.retrieveRamGo(payload)),
      mergeMap((responseRamGo: IResponseRamGo) => {
        return [
          RETRIEVE_RAM_GO_SUCCESS({
            responseRamGo,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCdGo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CD_GO),
      switchMap(({ payload }) => this.api.retrieveCdGo(payload)),
      mergeMap((responseCdGo: IResponseCdGo) => {
        return [
          RETRIEVE_CD_GO_SUCCESS({
            responseCdGo,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveFraz$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_FRAZ),
      switchMap(({ payload }) => this.api.retrieveFraz(payload)),
      mergeMap((responseFraz: IResponseFraz) => {
        return [
          RETRIEVE_FRAZ_SUCCESS({
            responseFraz,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRecapito$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RECAPITO),
      switchMap(({ idFraz }) => this.api.retrieveRecapito(idFraz)),
      mergeMap((responseRecapito: IResponseRecapito) => {
        return [
          RETRIEVE_RECAPITO_SUCCESS({
            responseRecapito,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveListaCatalogoMateriale$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_LISTA_CATALOGO_MATERIALE),
      switchMap(() => this.api.retrieveListaCatalogoMateriale()),
      mergeMap(
        (responseListaCatalogoMateriale: IResponseListaCatalogoMateriale) => {
          return [
            RETRIEVE_LISTA_CATALOGO_MATERIALE_SUCCESS({
              responseListaCatalogoMateriale,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadMaterialsCatalogue$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DOWNLOAD_CATALOGO_MATERIALE),
      switchMap(({ payload }) =>
        this.api.downloadCatalogoMateriale(
          payload?.sortKey,
          payload?.sortDirection
        ).pipe(
          map((response: HttpResponse<ArrayBuffer>) => {
            if (!response.body) {
              return DOWNLOAD_FILE_FAILURE({ error: 'Empty response body' });
            }
            const fileName = this.extractFileName(
              response.headers.get('Content-Disposition'),
              'Catalogo_Materiale.xlsx'
            );
            const blob = new Blob([
              response.body
            ], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            return DOWNLOAD_FILE({
              file: blob,
              fileName
            });
          }),
          catchError((error: HttpErrorResponse) =>
            of(DOWNLOAD_FILE_FAILURE({ error }))
          )
        )
      )
    )
  );

  /**
   * Estrae il nome file dall'header Content-Disposition, oppure restituisce il fallback.
   */
  private extractFileName(
    contentDisposition: string | null,
    fallback: string
  ): string {
    if (!contentDisposition) {
      return fallback;
    }
    const match = contentDisposition.match(/filename="?([^";]+)"?/i);
    return match?.[1]?.trim() ?? fallback;
  }

  retrieveRegoleOrdine$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REGOLE_ORDINE),
      switchMap(() => this.api.retrieveRegoleOrdine()),
      mergeMap((responseRegoleOrdine: IResponseRegoleOrdine) => {
        return [
          RETRIEVE_REGOLE_ORDINE_SUCCESS({
            responseRegoleOrdine,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveStoricoOrdini$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_ORDER_HISTORY),
      switchMap(({ payload }: { payload: PayloadOrderHistory }) =>
        this.api.retrieveStoricoOrdini(payload)
      ),
      mergeMap((responseStoricoOrdini: ResponseOrderHistory) => {
        return [
          RETRIEVE_ORDER_HISTORY_SUCCESS({
            responseStoricoOrdini,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveStoricoOrdiniProfili$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_STORICO_ORDINI_PROFILI),
      switchMap(() => this.api.retrieveStoricoOrdiniProfili()),
      mergeMap(
        (responseStoricoOrdiniProfili: IResponseStoricoOrdiniProfili) => {
          return [
            RETRIEVE_STORICO_ORDINI_PROFILI_SUCCESS({
              responseStoricoOrdiniProfili,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveStoricoOrdiniPartner$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_STORICO_ORDINI_PARTNER),
      switchMap(() => this.api.retrieveStoricoOrdiniPartner()),
      mergeMap((responseStoricoOrdiniPartner: IResponseStoricoOrdiniPartner) => {
        return [
          RETRIEVE_STORICO_ORDINI_PARTNER_SUCCESS({
            responseStoricoOrdiniPartner,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveListaCatalogoMateriale$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SAVE_LISTA_CATALOGO_MATERIALE),
      switchMap(({ payload }: { payload: ISaveListaCatalogoMateriale }) =>
        this.api.saveListaCatalogoMateriale(payload)
      ),
      mergeMap((response: GenericResponse) => {
        if (response.esito === EsitoEnum.OK) {
          return [
            ADD_TOAST_NOTIFICATION({
              notificationMessage: {
                type: NotificationTypeEnum.SUCCESS,
                description: 'Configurazioni aggiornate con successo.',
              },
            }),
            RETRIEVE_LISTA_CATALOGO_MATERIALE(),
          ];
        }

        return [
          ADD_TOAST_NOTIFICATION({
            notificationMessage: {
              type: NotificationTypeEnum.ERROR,
              description:
                response.errorDescr || 'Configurazioni non aggiornate.',
            },
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveConfigurazioneApprovvigionamento$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SAVE_CONFIGURAZIONE_APPROVIGIONAMENTO),
      switchMap(
        ({ payload }: { payload: IPayloadConfigurazioneApprovvigionamento }) =>
          this.api.saveConfigurazioneApprovvigionamento(payload)
      ),
      mergeMap((response: GenericResponse) => {
        if (response.esito === EsitoEnum.OK) {
          return [
            ADD_TOAST_NOTIFICATION({
              notificationMessage: {
                type: NotificationTypeEnum.SUCCESS,
                description: 'Configurazioni aggiornate con successo.',
              },
            }),
            RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO(),
          ];
        }

        return [
          ADD_TOAST_NOTIFICATION({
            notificationMessage: {
              type: NotificationTypeEnum.ERROR,
              description:
                response.errorDescr || 'Configurazioni non aggiornate.',
            },
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveListaCluster$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_LISTA_CLUSTER),
      switchMap(() => this.api.retrieveListaCluster()),
      mergeMap((responseListaCluster: IResponseCluster) => {
        return [
          RETRIEVE_LISTA_CLUSTER_SUCCESS({
            responseListaCluster,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveConfigurazioneApprovvigionamento$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO),
      switchMap(() => this.api.retrieveListaConfigurazioneApprovvigionamento()),
      map(
        (
          responseConfigurazioneApprovvigionamento: IResponseConfigurazioneApprovvigionamento
        ) => {
          return RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO_SUCCESS({
            responseConfigurazioneApprovvigionamento,
          });
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveListaFrazionario$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIVE_LISTA_FRAZIONARIO),
      switchMap(({ payload }: { payload: any }) => this.api.retrieveListaFrazionario(payload)),
      map(
        (
          responseListFrazionario: IResponseOrdiniApprovvigionamento
        ) => {
          return RETRIVE_LISTA_FRAZIONARIO_SUCCESS({
            responseListFrazionario,
          });
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrievePinRecovery$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_PIN_RECOVERY),
      switchMap(({ payload }: { payload: IPinRecoveryPayload }) => this.api.retrievePinRecovery(payload)),
      map(
        (
          responsePinRecovery: IResponsePinRecovery
        ) => {
          return RETRIEVE_PIN_RECOVERY_SUCCESS({
            responsePinRecovery,
          });
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  constructor(private actions$: Actions, private api: ApiService) {}
}
